export const PARTNER_MODULE_ID = 'partner-module-id';
